import React, { useEffect, useState } from "react";
import { useGlobalContext } from "store/contexts/globalContext";
import GeneralService from "services/GeneralService";
import InfiniteScroll from "react-infinite-scroll-component";
import Scrollbar from "react-scrollbars-custom";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import SearchPostList from "components/SearchPostList/SearchPostList";
import SearchInputField from "components/SearchInputField";
import SidebarSearchFilter from "components/SidebarSearchFilter";
import usePrevious from "hooks/usePrevious";
import classNames from "classnames";
import { useParams } from "react-router-dom";

function SearchedContent() {
  const { globalSearch, setGlobalSearch } = useGlobalContext();
  const { teamId } = useParams();
  const [searchValue, setSearchValue] = useState();
  const [searchPosts, setSearchPosts] = useState([]);
  const [selectSearchFilter, setSearchFilter] = useState(
    teamId ? teamId : "All"
  );
  const previousSearchValue = usePrevious(selectSearchFilter);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    if (globalSearch !== searchValue) {
      setSearchValue(globalSearch);
      setSearchPosts([]);
      setTotal("");
    }

    if (
      globalSearch &&
      globalSearch === searchValue &&
      previousSearchValue === selectSearchFilter &&
      page === 1
    ) {
      return;
    }

    (async () => {
      setLoading(true);
      try {
        var response = await GeneralService.postGlobalSearch({
          content: globalSearch,
          page: page,
          team_id: selectSearchFilter,
        });

        if (page > 1) {
          setSearchPosts([...searchPosts, ...response.data.data]);
        }

        if (page === 1) {
          setSearchPosts([...response.data.data]);
        }

        setTotal(response.data.meta.total);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    })();

    // eslint-disable-next-line
  }, [page, globalSearch, selectSearchFilter]);

  const getNextPageData = () => setPage(page + 1);

  const LoadingContainer = (
    <>
      {loading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!loading && (
        <h4 style={{ width: "20%" }}>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  const handleSearched = async (searchValue) => {
    setGlobalSearch(searchValue);
  };

  const searchWithinTeam = (id) => {
    setSearchPosts([]);
    setTotal("");
    setSearchFilter(id);
  };

  return (
    <div className="searchPage">
      <div className="row">
        {!teamId && (
          <div className={"col-lg-3"}>
            <SidebarSearchFilter
              selectSearchFilter={selectSearchFilter}
              searchWithinTeam={searchWithinTeam}
            />
          </div>
        )}
        <div
          className={classNames({
            "col-lg-9": teamId ? false : true,
            "col-lg-12": teamId ? true : false,
          })}
        >
          <SearchInputField
            className="searchFieldPage"
            handleSearched={handleSearched}
            value={globalSearch}
          />
          <div>
            <Scrollbar
              translateContentSizeYToHolder={true}
              disableTracksWidthCompensation={true}
              removeTracksWhenNotUsed={true}
              className={"searchScrollBar"}
            >
              <div className="mainRootContainer">
                <InfiniteScroll
                  style={{
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  dataLength={total ?? 0}
                  next={getNextPageData}
                  hasMore={searchPosts.length !== total}
                  loader={LoadingContainer}
                  scrollableTarget="main-panel-right"
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      {total > 0 && <b>Keep Engaging! </b>}
                    </p>
                  }
                >
                  <SearchPostList
                    posts={searchPosts}
                    total={total}
                    loading={loading}
                  />
                </InfiniteScroll>
              </div>
            </Scrollbar>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchedContent;
